// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ComponentsModal.css */

.cmp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1060;
  padding: 1rem;
}

.cmp-modal {
  background: var(--bg-surface);
  border-radius: 12px;
  width: 100%;
  max-width: 860px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 64px rgba(0,0,0,0.25);
  overflow: hidden;
}

/* Header */
.cmp-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: #0f172a;
  color: #fff;
  flex-shrink: 0;
}

.cmp-header-icon { font-size: 2rem; }

.cmp-header h3 {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
}

.cmp-header p {
  font-size: 0.8125rem;
  color: #94a3b8;
  margin: 0;
}

.cmp-close {
  margin-left: auto;
  background: var(--bg-toolbar);
  border: none;
  color: #fff;
  border-radius: 6px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cmp-close:hover { background: var(--slate-300); }

/* Body */
.cmp-body {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
  flex: 1 1;
}

.cmp-top-actions {
  margin-bottom: 1rem;
}

.cmp-loading, .cmp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 3rem 2rem;
  color: var(--text-muted);
}
.cmp-empty span { font-size: 3rem; }
.cmp-empty p    { font-size: 1rem; margin: 0; }

/* Card */
.cmp-card {
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.cmp-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: var(--bg-toolbar);
  border-bottom: 1px solid var(--border);
}

.cmp-card-icon { font-size: 1.5rem; flex-shrink: 0; }

.cmp-card-info {
  flex: 1 1;
  min-width: 0;
}
.cmp-card-info strong { display: block; font-size: 0.9375rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--text-primary); }
.cmp-card-info span   { font-size: 0.8125rem; color: var(--text-muted); }

.cmp-status {
  font-size: 0.75rem;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
}
.cmp-status--active  { background: rgba(16,185,129,.15); color: #6ee7b7; }
.cmp-status--faulty  { background: rgba(239,68,68,.15);  color: #f87171; }
.cmp-status--spare   { background: rgba(245,158,11,.15); color: #fcd34d; }

.cmp-card-actions {
  display: flex;
  gap: 0.25rem;
  flex-shrink: 0;
}

.cmp-icon-btn {
  background: none;
  border: 1px solid var(--slate-300);
  border-radius: 5px;
  padding: 3px 8px;
  cursor: pointer;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  transition: background 0.12s;
}
.cmp-icon-btn:hover { background: var(--bg-input); }
.cmp-icon-btn--del:hover { background: rgba(239,68,68,.15); border-color: rgba(239,68,68,.3); }

/* Port table */
.cmp-ports-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.cmp-ports-table th {
  background: var(--bg-toolbar);
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  padding: 0.5rem 0.875rem;
  text-align: left;
  border-bottom: 1px solid var(--border);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cmp-ports-table td {
  padding: 0.5rem 0.875rem;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
  color: var(--text-primary);
}

.cmp-ports-table tr:last-child td { border-bottom: none; }
.cmp-ports-table tr:hover td { background: rgba(var(--accent-rgb),.06); }

.cmp-port-type {
  font-family: monospace;
  font-size: 0.75rem;
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  padding: 1px 5px;
  border-radius: 3px;
}

.cmp-mac {
  font-size: 0.75rem;
  color: var(--accent-l);
}

.cmp-port-connected { color: #6ee7b7; }
.cmp-port-free      { color: var(--text-muted); }
.cmp-cable          { color: var(--text-muted); font-size: 0.75rem; margin-left: 4px; }

.cmp-team-badge {
  font-size: 0.72rem;
  background: var(--accent);
  color: var(--bg-card, #1e293b);
  border-radius: 4px;
  padding: 2px 6px;
}

.cmp-no-ports {
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: var(--text-muted);
  font-style: italic;
}

.cmp-link {
  background: none;
  border: none;
  color: var(--accent-l);
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  text-decoration: underline;
}

/* Buttons */
.cmp-btn-primary {
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.cmp-btn-primary:hover:not(:disabled) { background: var(--accent-dark); }
.cmp-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

.cmp-btn-secondary {
  background: var(--bg-input);
  color: var(--text-secondary);
  border: 1px solid var(--slate-300);
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  cursor: pointer;
}
.cmp-btn-secondary:hover:not(:disabled) { background: var(--bg-toolbar); }

.cmp-btn-danger {
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  cursor: pointer;
}
.cmp-btn-danger:hover:not(:disabled) { background: #b91c1c; }
.cmp-btn-danger:disabled { opacity: 0.5; cursor: not-allowed; }

/* Form modal */
.cmp-form-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1070;
  padding: 1rem;
}

.cmp-form-modal {
  background: var(--bg-surface);
  border-radius: 10px;
  width: 100%;
  max-width: 560px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
  overflow: hidden;
}

.cmp-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: var(--bg-toolbar);
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
}

.cmp-form-header h4 { font-size: 0.9375rem; font-weight: 600; margin: 0; }

.cmp-form-body {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.cmp-form-row {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cmp-form-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
  min-width: 100px;
}

.cmp-form-field--grow { flex: 2 1; }

.cmp-form-field label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.cmp-input {
  padding: 0.45rem 0.75rem;
  border: 1px solid var(--slate-300);
  border-radius: 6px;
  font-size: 0.875rem;
  width: 100%;
  box-sizing: border-box;
  background: var(--bg-input);
  color: var(--text-primary);
}
.cmp-input option {
  background: var(--bg-surface);
  color: var(--text-primary);
}
.cmp-input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2); }

.cmp-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border);
  margin-top: 0.25rem;
}

/* Confirm dialogs */
.cmp-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
}

.cmp-confirm {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 1.5rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}

.cmp-confirm h4 { font-size: 1rem; font-weight: 700; margin-bottom: 0.5rem; color: var(--text-primary); }
.cmp-confirm p  { font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 1.25rem; }

.cmp-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsModal.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,mBAAmB,eAAe,EAAE;;AAEpC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,mBAAmB,4BAA4B,EAAE;;AAEjD,SAAS;AACT;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,kBAAkB,eAAe,EAAE;AACnC,kBAAkB,eAAe,EAAE,SAAS,EAAE;;AAE9C,SAAS;AACT;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA,iBAAiB,iBAAiB,EAAE,cAAc,EAAE;;AAEpD;EACE,SAAO;EACP,YAAY;AACd;AACA,wBAAwB,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,0BAA0B,EAAE;AAC1J,wBAAwB,oBAAoB,EAAE,wBAAwB,EAAE;;AAExE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,uBAAuB,gCAAgC,EAAE,cAAc,EAAE;AACzE,uBAAuB,+BAA+B,GAAG,cAAc,EAAE;AACzE,uBAAuB,gCAAgC,EAAE,cAAc,EAAE;;AAEzE;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA,sBAAsB,2BAA2B,EAAE;AACnD,2BAA2B,+BAA+B,EAAE,gCAAgC,EAAE;;AAE9F,eAAe;AACf;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,+BAA+B,uCAAuC,EAAE;;AAExE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sBAAsB,cAAc,EAAE;AACtC,sBAAsB,wBAAwB,EAAE;AAChD,sBAAsB,wBAAwB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEtF;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,wCAAwC,8BAA8B,EAAE;AACxE,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA,0CAA0C,6BAA6B,EAAE;;AAEzE;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;AACA,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,eAAe;AACf;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;EAC7B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,sBAAsB,oBAAoB,EAAE,gBAAgB,EAAE,SAAS,EAAE;;AAEzE;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA,wBAAwB,SAAO,EAAE;;AAEjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA,mBAAmB,aAAa,EAAE,2BAA2B,EAAE,gDAAgD,EAAE;;AAEjH;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,uCAAuC;AACzC;;AAEA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,0BAA0B,EAAE;AACxG,kBAAkB,mBAAmB,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;;AAE7F;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["/* ComponentsModal.css */\r\n\r\n.cmp-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1060;\r\n  padding: 1rem;\r\n}\r\n\r\n.cmp-modal {\r\n  background: var(--bg-surface);\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  max-width: 860px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 24px 64px rgba(0,0,0,0.25);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Header */\r\n.cmp-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 1.25rem 1.5rem;\r\n  background: #0f172a;\r\n  color: #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cmp-header-icon { font-size: 2rem; }\r\n\r\n.cmp-header h3 {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.cmp-header p {\r\n  font-size: 0.8125rem;\r\n  color: #94a3b8;\r\n  margin: 0;\r\n}\r\n\r\n.cmp-close {\r\n  margin-left: auto;\r\n  background: var(--bg-toolbar);\r\n  border: none;\r\n  color: #fff;\r\n  border-radius: 6px;\r\n  width: 30px;\r\n  height: 30px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.cmp-close:hover { background: var(--slate-300); }\r\n\r\n/* Body */\r\n.cmp-body {\r\n  padding: 1.25rem 1.5rem;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.cmp-top-actions {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.cmp-loading, .cmp-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.75rem;\r\n  padding: 3rem 2rem;\r\n  color: var(--text-muted);\r\n}\r\n.cmp-empty span { font-size: 3rem; }\r\n.cmp-empty p    { font-size: 1rem; margin: 0; }\r\n\r\n/* Card */\r\n.cmp-card {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  margin-bottom: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.cmp-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem 1rem;\r\n  background: var(--bg-toolbar);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.cmp-card-icon { font-size: 1.5rem; flex-shrink: 0; }\r\n\r\n.cmp-card-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n.cmp-card-info strong { display: block; font-size: 0.9375rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--text-primary); }\r\n.cmp-card-info span   { font-size: 0.8125rem; color: var(--text-muted); }\r\n\r\n.cmp-status {\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  padding: 2px 8px;\r\n  border-radius: 10px;\r\n  white-space: nowrap;\r\n}\r\n.cmp-status--active  { background: rgba(16,185,129,.15); color: #6ee7b7; }\r\n.cmp-status--faulty  { background: rgba(239,68,68,.15);  color: #f87171; }\r\n.cmp-status--spare   { background: rgba(245,158,11,.15); color: #fcd34d; }\r\n\r\n.cmp-card-actions {\r\n  display: flex;\r\n  gap: 0.25rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cmp-icon-btn {\r\n  background: none;\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 5px;\r\n  padding: 3px 8px;\r\n  cursor: pointer;\r\n  font-size: 0.8125rem;\r\n  color: var(--text-secondary);\r\n  transition: background 0.12s;\r\n}\r\n.cmp-icon-btn:hover { background: var(--bg-input); }\r\n.cmp-icon-btn--del:hover { background: rgba(239,68,68,.15); border-color: rgba(239,68,68,.3); }\r\n\r\n/* Port table */\r\n.cmp-ports-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.cmp-ports-table th {\r\n  background: var(--bg-toolbar);\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  padding: 0.5rem 0.875rem;\r\n  text-align: left;\r\n  border-bottom: 1px solid var(--border);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.cmp-ports-table td {\r\n  padding: 0.5rem 0.875rem;\r\n  border-bottom: 1px solid var(--border);\r\n  vertical-align: middle;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.cmp-ports-table tr:last-child td { border-bottom: none; }\r\n.cmp-ports-table tr:hover td { background: rgba(var(--accent-rgb),.06); }\r\n\r\n.cmp-port-type {\r\n  font-family: monospace;\r\n  font-size: 0.75rem;\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  padding: 1px 5px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.cmp-mac {\r\n  font-size: 0.75rem;\r\n  color: var(--accent-l);\r\n}\r\n\r\n.cmp-port-connected { color: #6ee7b7; }\r\n.cmp-port-free      { color: var(--text-muted); }\r\n.cmp-cable          { color: var(--text-muted); font-size: 0.75rem; margin-left: 4px; }\r\n\r\n.cmp-team-badge {\r\n  font-size: 0.72rem;\r\n  background: var(--accent);\r\n  color: var(--bg-card, #1e293b);\r\n  border-radius: 4px;\r\n  padding: 2px 6px;\r\n}\r\n\r\n.cmp-no-ports {\r\n  padding: 0.75rem 1rem;\r\n  font-size: 0.875rem;\r\n  color: var(--text-muted);\r\n  font-style: italic;\r\n}\r\n\r\n.cmp-link {\r\n  background: none;\r\n  border: none;\r\n  color: var(--accent-l);\r\n  cursor: pointer;\r\n  font-size: inherit;\r\n  padding: 0;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Buttons */\r\n.cmp-btn-primary {\r\n  background: var(--accent);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.5rem 1rem;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n.cmp-btn-primary:hover:not(:disabled) { background: var(--accent-dark); }\r\n.cmp-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }\r\n\r\n.cmp-btn-secondary {\r\n  background: var(--bg-input);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 6px;\r\n  padding: 0.5rem 1rem;\r\n  font-size: 0.875rem;\r\n  cursor: pointer;\r\n}\r\n.cmp-btn-secondary:hover:not(:disabled) { background: var(--bg-toolbar); }\r\n\r\n.cmp-btn-danger {\r\n  background: #dc2626;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.5rem 1rem;\r\n  font-size: 0.875rem;\r\n  cursor: pointer;\r\n}\r\n.cmp-btn-danger:hover:not(:disabled) { background: #b91c1c; }\r\n.cmp-btn-danger:disabled { opacity: 0.5; cursor: not-allowed; }\r\n\r\n/* Form modal */\r\n.cmp-form-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1070;\r\n  padding: 1rem;\r\n}\r\n\r\n.cmp-form-modal {\r\n  background: var(--bg-surface);\r\n  border-radius: 10px;\r\n  width: 100%;\r\n  max-width: 560px;\r\n  box-shadow: 0 20px 60px rgba(0,0,0,0.25);\r\n  overflow: hidden;\r\n}\r\n\r\n.cmp-form-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 1rem 1.25rem;\r\n  background: var(--bg-toolbar);\r\n  border-bottom: 1px solid var(--border);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.cmp-form-header h4 { font-size: 0.9375rem; font-weight: 600; margin: 0; }\r\n\r\n.cmp-form-body {\r\n  padding: 1.25rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.875rem;\r\n}\r\n\r\n.cmp-form-row {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.cmp-form-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  flex: 1;\r\n  min-width: 100px;\r\n}\r\n\r\n.cmp-form-field--grow { flex: 2; }\r\n\r\n.cmp-form-field label {\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.cmp-input {\r\n  padding: 0.45rem 0.75rem;\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 6px;\r\n  font-size: 0.875rem;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n}\r\n.cmp-input option {\r\n  background: var(--bg-surface);\r\n  color: var(--text-primary);\r\n}\r\n.cmp-input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px rgba(var(--accent-rgb),.2); }\r\n\r\n.cmp-form-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.75rem;\r\n  padding-top: 0.5rem;\r\n  border-top: 1px solid var(--border);\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n/* Confirm dialogs */\r\n.cmp-confirm-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1080;\r\n}\r\n\r\n.cmp-confirm {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  box-shadow: 0 20px 60px rgba(0,0,0,0.5);\r\n}\r\n\r\n.cmp-confirm h4 { font-size: 1rem; font-weight: 700; margin-bottom: 0.5rem; color: var(--text-primary); }\r\n.cmp-confirm p  { font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 1.25rem; }\r\n\r\n.cmp-confirm-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.75rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
